import { AttachFile, Euro, PowerSettingsNew, TextFields } from "@mui/icons-material";
import { Stack } from "@mui/material";
import { useSelector } from "@tanstack/react-store";
import type { ReactNode } from "react";
import { useTranslation } from "react-i18next";
import { withForm } from "@/components/Forms";
import CustomCard from "../../CreateDeliveryDeal/ui/custom-card";
import { deliveryOptionFormOpts } from "../option.form.opts";

const FLAGS: {
  name: "active" | "requireInput" | "requiresFile" | "dynamicPricing";
  labelKey: string;
  hintKey: string;
  icon: ReactNode;
}[] = [
  {
    name: "active",
    labelKey: "deliveryOption.behavior.active",
    hintKey: "deliveryOption.behavior.activeHint",
    icon: <PowerSettingsNew fontSize="small" />,
  },
  {
    name: "dynamicPricing",
    labelKey: "deliveryOption.behavior.dynamicPricing",
    hintKey: "deliveryOption.behavior.dynamicPricingHint",
    icon: <Euro fontSize="small" />,
  },
  {
    name: "requireInput",
    labelKey: "deliveryOption.behavior.requireInput",
    hintKey: "deliveryOption.behavior.requireInputHint",
    icon: <TextFields fontSize="small" />,
  },
  {
    name: "requiresFile",
    labelKey: "deliveryOption.behavior.requiresFile",
    hintKey: "deliveryOption.behavior.requiresFileHint",
    icon: <AttachFile fontSize="small" />,
  },
];

export const BehaviorSection = withForm({
  ...deliveryOptionFormOpts,
  render: ({ form }) => {
    const { t } = useTranslation();
    const requiresFile = useSelector(form.store, (state) => state.values.requiresFile);
    return (
      <CustomCard
        label={t("deliveryOption.behavior.title")}
        subtitle={t("deliveryOption.behavior.subtitle")}
      >
        <Stack spacing={2}>
          {FLAGS.map(({ name, labelKey, hintKey, icon }) => (
            <form.AppField
              key={name}
              name={name}
              listeners={
                name === "requiresFile"
                  ? {
                      onChange: ({ value }) => {
                        if (!value) {
                          form.setFieldValue("fileType", null);
                          form.setFieldValue("requiresMultipleFiles", false);
                        }
                      },
                    }
                  : undefined
              }
            >
              {(f) => <f.SwitchField label={t(labelKey)} hint={t(hintKey)} icon={icon} />}
            </form.AppField>
          ))}
          {requiresFile && (
            <>
              <form.AppField name="requiresMultipleFiles">
                {(f) => (
                  <f.SwitchField
                    label={t("deliveryOption.behavior.requiresMultipleFiles")}
                    hint={t("deliveryOption.behavior.requiresMultipleFilesHint")}
                  />
                )}
              </form.AppField>
              <form.AppField name="fileType">
                {(f) => (
                  <f.SelectField
                    label={t("deliveryOption.behavior.fileType")}
                    clearable
                    emptyLabel={t("deliveryOption.behavior.fileTypePlaceholder", {
                      defaultValue: "Select file type",
                    })}
                    options={[
                      {
                        label: t("deliveryOption.behavior.fileTypeImage"),
                        value: "IMAGE",
                      },
                      {
                        label: t("deliveryOption.behavior.fileTypePdf"),
                        value: "PDF",
                      },
                    ]}
                  />
                )}
              </form.AppField>
            </>
          )}
        </Stack>
      </CustomCard>
    );
  },
});
